import type { Map } from 'mapbox-gl';

export function resumeMapboxMap(map: Map | undefined): void {
  if (!map) {
    return;
  }

  try {
    map.resize();
    map.triggerRepaint();
  } catch {
    // Map instance may already be destroyed.
  }
}
